<template>
  <div class="dynamic-form">
    <div class="tab-wrap" v-if="config.length > 1">
      <div class="tab-header-wrap">
        <div
          class="tab-item"
          v-for="(item, index) in config"
          :key="index"
          :class="tabActive === index ? 'active' : ''"
          @click="onChangeTab(index)"
        >
          {{ item.formTitle }}
        </div>
      </div>
    </div>
    <div class="tab-content-wrap">
      <div v-if="activeFormItem && activeFormItem.formConfig">
        <template v-for="(formItem, idx) in activeFormItem.formConfig">
          <template v-if="formItem.sectionFlag">
            <div :key="formItem.sectionTitle" class="section-title-block">
              <span style="font-size: 16px;font-weight: 500;color: #333;margin:10px 10px;">{{formItem.sectionTitle}}</span>            
              <template v-for="(childFormItem, childIdx) in formItem.children">
                <FormItem
                  v-if="childFormItem.fieldType !== 'RowTable' && childFormItem.fieldType !== 'Table'"
                  :key="idx+childIdx+100"
                  :field="childFormItem"
                  :form="form"
                  :disabled="disabled"
                ></FormItem>
                <div v-else :key="idx+childIdx+110" :class="childFormItem.fieldType === 'RowTable' ? 'splitblock' : ''">
                  <div class="block-title">
                    <span style="color:red;margin-right:3px" v-if="childFormItem.isRequire">*</span>{{ childFormItem.fieldName }}
                    <div class="block-title-extra">
                      <div v-if="!disabled" class="add-contact" @click="onEdit(null, {}, childFormItem)">添加</div>
                    </div>
                  </div>
                  <div class="row-form">
                    <Table :columns="form[childFormItem.fieldCode].columns" :rows-data="form[childFormItem.fieldCode].rowsData">
                      <template slot-scope='scope'>
                        <div v-if="!disabled && scope.col.key === 'op'" class="table-op">
                          <a @click="onEdit(scope.index, scope.row, childFormItem)">编辑</a>
                          <span class="split-line"></span>
                          <a class="del" @click="onDelete(scope.index, scope.row, childFormItem)">删除</a>
                        </div>
                      </template>
                    </Table>                
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <FormItem
              v-if="formItem.fieldType !== 'RowTable' && formItem.fieldType !== 'Table'"
              :key="idx"
              :field="formItem"
              :form="form"
              :disabled="disabled"
            ></FormItem>
            <div v-else :key="idx" :class="formItem.fieldType === 'RowTable' ? 'splitblock' : ''">
              <div class="block-title">
                <span style="color:red;margin-right:3px" v-if="formItem.isRequire">*</span>{{ formItem.fieldName }}
                <div class="block-title-extra">
                  <div v-if="!disabled" class="add-contact" @click="onEdit(null, {}, formItem)">添加</div>
                </div>
              </div>
              <div class="row-form">
                <Table :columns="form[formItem.fieldCode].columns" :rows-data="form[formItem.fieldCode].rowsData">
                  <template slot-scope='scope'>
                    <div v-if="!disabled && scope.col.key === 'op'" class="table-op">
                      <a @click="onEdit(scope.index, scope.row, formItem)">编辑</a>
                      <span class="split-line"></span>
                      <a class="del" @click="onDelete(scope.index, scope.row, formItem)">删除</a>
                    </div>
                  </template>
                </Table>
                <!-- <FormItem
                  v-for="(childItem, childIdx) in formItem.childConfig"
                  :key="childIdx"
                  :field="childItem"
                  :form="form[formItem.fieldCode]"
                ></FormItem> -->
              </div>
            </div>
          </template>
          
        </template>
      </div>
      <Empty v-else />
    </div>
    <Modal :visible="tableEditVisible">
      <EditFormModal
        v-if="tableForm"
        :columns="tableColumns"
        :formData="tableForm"
        :disabled="disabled"
        @confirm="onTableFormConfirm"
        @cancel="onTableFormModalClose"
      />
    </Modal>
  </div>
</template>

<script>
import FormItem from "@/components/FormItem";
import Table from '@/components/Table';
import Modal from '@/components/Modal';
import modal from '@/components';
import EditFormModal from './EditForm';
export default {
  data() {
    return {
      tableForm: null,
      tableColumns: [],
      tableEditVisible: false
    }
  },
  computed: {
    activeFormItem() {
      if (this.config.length && this.config[this.tabActive]) {
        let config = this.config[this.tabActive];
     
        const hasValidSectionTitle = config.formConfig.some(item => {
          return item.sectionTitle !== undefined && 
                item.sectionTitle !== null && 
                item.sectionTitle !== '';
        });

        if(!hasValidSectionTitle){
          //没分段落
          return config;
        }else{
          // 步骤1：创建分组映射（key: sectionTitle, value: 对应子数组）
          const groupMap = {};
          config.formConfig.forEach(item => {
            const key = item.sectionTitle;
            // 如果该分组不存在，初始化空数组
            if (!groupMap[key]) {
              groupMap[key] = [];
            }
            // 将当前项加入对应分组的子数组
            groupMap[key].push(item);
          });

          // 步骤2：将分组映射转换为目标数组（每个元素带 sectionFlag、sectionTitle、children）
          const newArr = Object.keys(groupMap).map(key => ({
            sectionTitle: key,    // 分组标题
            sectionFlag: true,    // 你要求的标识字段
            children: groupMap[key] // 分组后的子数组
          }));
          config.formConfig = newArr;
          return config;
        }
       
      }
      return null;
    },
  },
  props: {
    tabActive: {
      default: 0
    },
    config: {
      default: () => [],
    },
    form: {
      require: true,
    },
    disabled: {
      default: false
    }
  },
  components: {
    FormItem,
    Table,
    Modal,
    EditFormModal
  },
  mounted:()=>{
    
  },
  methods: {
    onChangeTab(idx) {
      this.$emit('changeTab', idx);
    },
    onEdit(index, row, formItem) {            
      const tableForm = this.form[formItem.fieldCode];
      this.tableForm = {
        ...tableForm.tableForm
      }

     

      this.tableColumns = tableForm.columns.filter(col => col.key !== 'op').map(col => {
        if(col.fieldType=='File' ){
          this.tableForm[col.dataIndex].value = row[col.dataIndex] || [];
        }else{
          this.tableForm[col.dataIndex].value = row[col.dataIndex] || '';
        }          
        //工程奖特殊特殊场景  20240328
        if(formItem.fieldCode == 'mainCompletedStaffList' && (!tableForm.rowsData || tableForm.rowsData.length == 0)){
          return {...col,fieldPlaceholder:'必须是项目负责人'};
        }else{
          return col;
        }                
      })
      this.tableForm.id = index;
      this.formItem = formItem;
      this.tableEditVisible = true;
    },
    onDelete(index, row, formItem) {
      const tableForm = this.form[formItem.fieldCode];
      modal.confirm({
        title: '请确认是否删除？',
        confirm:() => {
          tableForm.rowsData.splice(index, 1);
        },
      });
    },
    onTableFormConfirm(newRow) {
      console.log(this.tableForm);
      if (this.tableForm.id || this.tableForm.id == 0) {
        this.form[this.formItem.fieldCode].rowsData[this.tableForm.id] = newRow;
      } else {
        this.form[this.formItem.fieldCode].rowsData.push(newRow);
      }
      this.tableEditVisible = false;
    },
    onTableFormModalClose() {
      this.tableEditVisible = false;
    }
  },
};
</script>

<style lang="less" scoped>
.dynamic-form {
  width: 100%;

  .tab-wrap {
    width: 100%;
    overflow-x: auto;
    border-bottom: 1px solid #eeeeee;

    .tab-header-wrap {
      display: flex;
      min-width: 100%;
      width: max-content;
    }

    .tab-item {
      padding: 10px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #131415;
      border-bottom: 1px solid transparent;
      cursor: pointer;

      &:hover,
      &.active {
        color: #06ae63;
        border-bottom: 1px solid #06ae63;
      }
    }
  }

  .tab-content-wrap {
    padding: 20px;
  }

  .section-title-block {
    background: #f7f7f7;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 12px;

    span {
      display: block;
      text-align: center;
    }
  }

  .block-title {
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #787878;
    // border-bottom: 1px solid #ddd;

    &-extra {
      margin-left: auto;
      
      .add-contact {
        padding-left: 22px;
        cursor: pointer;
        background: url(../../../../assets/images/icon-add.png) no-repeat 0
          center;
        background-size: 18px 18px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #06AE63;
      }
    }
  }
  .row-form {
    padding: 10px 0px 20px 0px;
  }
    // border-bottom: 1px solid #ddd;

  .splitblock {
    margin-left: -10px;
  }
   
}
</style>